module.exports = __webpack_public_path__ + "img/bg.2492f991.png";